<app-spinner *ngIf="loading"></app-spinner>
<div class="filters-modal" *ngIf="!loading">
  <div md-dialog-content *ngIf="filters" class="filters-wrapper">
    <div class="columns">
      <div class="column">
        <div>
          <h4>Filter by dates</h4>
          <div class="dates-filter-container">
            <md2-datepicker
              [(ngModel)]="filters.startDate"
              format="dd/MM/y"
              placeholder="Start date"
              (change)="startDateChanged()"
            ></md2-datepicker>
            <md2-datepicker
              [(ngModel)]="filters.endDate"
              format="dd/MM/y"
              placeholder="End date"
              (change)="endDateChanged()"
            ></md2-datepicker>
            <div>
              <md-form-field>
                <input
                  type="number"
                  mdInput
                  placeholder="Week"
                  [(ngModel)]="filters.week"
                  min="1"
                  max="53"
                  (change)="weekChanged()"
                />
              </md-form-field>
              <md-form-field>
                <input
                  type="number"
                  mdInput
                  placeholder="Year"
                  [(ngModel)]="filters.year"
                  min="2000"
                  (change)="yearChanged()"
                />
              </md-form-field>
            </div>
            <div id="dayStart">
              3AM
              <md-slide-toggle
                [checked]="filters.midnightMode"
                (change)="dayStartChanged($event)"
              ></md-slide-toggle>
              12AM
            </div>
          </div>
        </div>
        <div>
          <h4>Filter by content</h4>
          <div class="edited-status">
            <md-select placeholder="Status" [(ngModel)]="filters.fieldStatus">
              <md-option
                *ngFor="let status of allStatus"
                [value]="status.value"
              >
                {{ status.value }}
              </md-option>
            </md-select>
            <md-select placeholder="Fields" [(ngModel)]="filters.field">
              <md-option *ngFor="let field of allFields" [value]="field.value">
                {{ field.value }}
              </md-option>
            </md-select>
            <md-select
              placeholder="Destinations"
              [(ngModel)]="filters.filterDestination"
            >
              <md-option
                *ngFor="let destination of allDestinations"
                [value]="destination.id"
              >
                {{ destination.value }}
              </md-option>
            </md-select>
            <md-form-field>
              <input
                type="text"
                mdInput
                placeholder="Search by text"
                [(ngModel)]="filters.keywords"
              />
            </md-form-field>
          </div>
        </div>
        <div>
          <h4>Filter by metadata</h4>
          <div class="advanced-fields">
            <md-select placeholder="Search by" [(ngModel)]="filters.idType">
              <md-option *ngFor="let type of allTypes" [value]="type.value">
                {{ type.value }}
              </md-option>
            </md-select>
            <md-form-field *ngIf="filters.idType === 'BroadcastId'">
              <input
                type="text"
                mdInput
                placeholder="Enter Id"
                pattern="^([e][0-9]+[c][0-9]+(ch)[0-9]+)?$"
                title="Broadcast Id example 'e123456789c987654321ch0'"
                (keyup)="checkBroadcastId()"
                [(ngModel)]="filters.idValue"
              />
            </md-form-field>
            <md-form-field
              *ngIf="
                filters.idType !== 'BroadcastId' &&
                filters.idType !== 'SpevId' &&
                filters.idType !== 'Affiliate' &&
                filters.idType !== 'Tiering' &&
                filters.idType !== 'ProductCode'
              "
            >
              <input
                type="text"
                mdInput
                placeholder="Enter Id"
                pattern="^([0-9]+)?$"
                title="Id example '123456789'"
                (keyup)="checkNumberId()"
                [(ngModel)]="filters.idValue"
              />
            </md-form-field>
            <md-form-field *ngIf="filters.idType === 'SpevId'">
              <input
                type="text"
                mdInput
                placeholder="Enter [SpevId]/[VariantId]"
                pattern="^([0-9]+((/)[0-9]+)?)?$"
                title="Spev Id example '12345' or '12345/123'"
                (keyup)="checkSpevId()"
                [(ngModel)]="filters.idValue"
              />
            </md-form-field>
            <md-select
              *ngIf="filters.idType === 'Affiliate'"
              placeholder="Affiliate"
              [(ngModel)]="filters.idValue"
            >
              <md-option
                *ngFor="let affiliate of allAffiliates"
                [value]="affiliate.id"
              >
                {{ affiliate.value }}
              </md-option>
            </md-select>
            <md-select
              *ngIf="filters.idType === 'Tiering'"
              placeholder="Tiering"
              [(ngModel)]="filters.idValue"
            >
              <md-option
                *ngFor="let tiering of allTierings"
                [value]="tiering.id"
              >
                {{ tiering.value }}
              </md-option>
            </md-select>
            <md-form-field *ngIf="filters.idType === 'ProductCode'">
              <input
                type="text"
                mdInput
                placeholder="Enter product code"
                pattern="^([A-Z]{4}[0-9]+)?$"
                title="Product code example : 'ABCE202201'"
                (keyup)="checkProductCode()"
                [(ngModel)]="filters.idValue"
              />
            </md-form-field>

            <div id="dayStart">
              <md-slide-toggle
                [checked]="filters.showHidden"
                (change)="showHiddenChanged($event)"
              ></md-slide-toggle>
              Show hidden
            </div>
          </div>
          <h4>Updated in the last ...</h4>
          <div class="last-hours">
            <md-form-field style="width: 60px">
              <input
                min="0"
                type="number"
                mdInput
                [(ngModel)]="filters.updatedInTheLastHours"
              />
            </md-form-field>
            <button
              md-raised-button
              (click)="changeValueUpdatedInTheLastHour(6)"
              [color]="filters.updatedInTheLastHours == 6 ? 'primary' : ''"
            >
              6h
            </button>
            <button
              md-raised-button
              (click)="changeValueUpdatedInTheLastHour(12)"
              [color]="filters.updatedInTheLastHours == 12 ? 'primary' : ''"
            >
              12h
            </button>
            <button
              md-raised-button
              (click)="changeValueUpdatedInTheLastHour(24)"
              [color]="filters.updatedInTheLastHours == 24 ? 'primary' : ''"
            >
              24h
            </button>
          </div>
          <hr />
          <div class="AlignWrapper">
            <div class="Sport">Sport</div>
            <div>
              <md-slide-toggle
                [checked]="midnightMode"
                (change)="changeTypeClassification($event)"
              ></md-slide-toggle>
            </div>
            <div class="NonSport">Non Sport</div>
          </div>
          <div class="selections">
            <app-list-selector
              *ngFor="let type of referentialTypes"
              #selector
              [type]="type"
              [multiple]="true"
              [values]="[]"
              [forceInter]="filters.forceLanguageInter"
              [nonSport]="isNonSportiveClassif"
              [selected]="filters.referentialEntities | valueFromEntity : type"
            >
            </app-list-selector>
          </div>
        </div>
      </div>
      <div class="column">
        <div>
          <div class="buttons">
            <h4>Linear Channels</h4>
            <div>
              <button md-raised-button (click)="selectAllLinearChannels()">
                Select All
              </button>
              <button md-raised-button (click)="clearLinearChannels()">
                Clear
              </button>
            </div>
          </div>
          <div>
            <md-button-toggle-group
              multiple
              class="channels-toggle-group"
              id="linear"
            >
              <md-button-toggle
                class="slot"
                *ngFor="let channel of linearChannels"
                (change)="channelToggleEvent($event.value)"
                [checked]="isChecked(channel)"
                [value]="channel"
              >
                <span>{{ channel.value }}</span>
              </md-button-toggle>
            </md-button-toggle-group>
          </div>
          <div>
            <div class="countries">
              <h4>Bonus Channels</h4>
              <md-select
                placeholder="Countries"
                [(ngModel)]="filters.broadcastingCountries"
                [multiple]="true"
                #countriesSelect="ngModel"
              >
                <md-option
                  disabled="disabled"
                  style="margin-left: -36px; color: black"
                >
                  <md-checkbox
                    name="selectAll"
                    style="margin-left: 4px"
                    color="accent"
                    (change)="
                      selectAllCountries(countriesSelect, countries, $event)
                    "
                    [checked]="allCountriesSelected()"
                    >Select All</md-checkbox
                  >
                </md-option>
                <hr />
                <md-option
                  *ngFor="let country of countries"
                  [value]="country"
                  >{{ country.value }}</md-option
                >
              </md-select>
            </div>
            <div class="buttons">
              <!-- Beam only available for USA market -->
              <button
                *ngIf="areBonusChannelsAvailable('isBeam')"
                md-raised-button
                [color]="allAreChecked('isBeam') ? 'primary' : ''"
                (click)="toggleAll('isBeam')"
              >
                Digital Exclusive Events
              </button>
              <!-- TNT SPORTS EXTRA only available for ENGLISH market -->
              <button
                *ngIf="areBonusChannelsAvailable('isBT')"
                md-raised-button
                [color]="allAreChecked('isBT') ? 'primary' : ''"
                (click)="toggleAll('isBT')"
              >
                TNT Sports
              </button>
              <button
                *ngIf="areBonusChannelsAvailable('isLE')"
                md-raised-button
                [color]="allAreChecked('isLE') ? 'primary' : ''"
                (click)="toggleAll('isLE')"
              >
                Live Event
              </button>
              <button
                *ngIf="areBonusChannelsAvailable('isLEXT')"
                md-raised-button
                [color]="allAreChecked('isLEXT') ? 'primary' : ''"
                (click)="toggleAll('isLEXT')"
              >
                Live Event Extra
              </button>
              <button
                *ngIf="areBonusChannelsAvailable('isMIPL')"
                md-raised-button
                [color]="allAreChecked('isMIPL') ? 'primary' : ''"
                (click)="toggleAll('isMIPL')"
              >
                Mileparken
              </button>
              <button
                *ngIf="areBonusChannelsAvailable('isTL')"
                md-raised-button
                [color]="allAreChecked('isTL') ? 'primary' : ''"
                (click)="toggleAll('isTL')"
              >
                Telia Liiga
              </button>
              <button md-raised-button (click)="selectAllBonusChannels()">
                Select All
              </button>
              <button md-raised-button (click)="clearBonusChannels()">
                Clear
              </button>
            </div>
            <md-button-toggle-group
              multiple
              class="channels-toggle-group"
              id="bonus"
            >
              <md-button-toggle
                class="slot"
                *ngFor="let channel of bonusChannels"
                (change)="channelToggleEvent($event.value)"
                [checked]="isChecked(channel)"
                [value]="channel"
              >
                <span>{{ channel.value }}</span>
              </md-button-toggle>
            </md-button-toggle-group>
          </div>
        </div>
      </div>
    </div>
  </div>

  <md-dialog-actions class="actions">
    <div>
      <md-slide-toggle
        [(ngModel)]="filters.forceLanguageInter"
        (change)="forceInterChanged()"
        >Force Inter language
      </md-slide-toggle>
    </div>
    <div>
      <button md-raised-button (click)="getUserFilter()">
        <md-icon>refresh</md-icon>
        Load filter
      </button>
      <button md-raised-button color="accent" (click)="saveUserFilter()">
        <md-icon>save</md-icon>
        Save filter
      </button>
      <button md-raised-button color="primary" (click)="resetFilters()">
        <md-icon>refresh</md-icon>
        Reset filters
      </button>
      <button md-dialog-close md-raised-button>
        <md-icon>cancel</md-icon>
        Cancel
      </button>
      <button
        md-raised-button
        color="accent"
        [mdTooltip]="
          !filters.startDate || !filters.endDate
            ? 'Start date or End date not selected'
            : ''
        "
        [disabled]="!filters.startDate || !filters.endDate || !idValueValid"
        (click)="saveFilters()"
      >
        <md-icon>check</md-icon>
        Validate
      </button>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/filters-modal/filters-modal.component.html